const MessagesModule = {
  components: {
    MessagesEmpty: MessagesEmpty,
    MessagesThreads: MessagesThreads,
    MessagesList: MessagesList,
  },
  data() {
    return {
      unread: 0,
      threads: [],
      selected: false,
    };
  },
  props: {
    tid: { default: false },
  },
  created() {
    //console.log('messages.created');

    this.$ws.on('open', () => {
      this.$ws.emit('threads.update');
    });

    this.$ws.emit('threads.update');
    this.$ws.on('threads.update', (payload) => {
      this.threads = payload.threads;
      //console.log('threads.update', payload, this.tid);
    });

    this.$ws.on('message.new', (message) => {
      //console.log('messages.message.new', message, new Date());
      this.threads.map((thread, i) => {
        if (thread._id === message.thread._id) {
          thread.updatedAt = new Date();
          ``;
          if (thread._id !== this.selected._id) {
            thread.unread = true;
          }
          this.$set(this.threads, i, thread);
        }
      });
      this.updateUnread();
    });
  },
  methods: {
    select(thread) {
      if (!thread) return;
      //console.log('thread.select', thread);
      this.updateUnread();
      this.selected = thread;
      if (this.tid !== thread._id) {
        this.$router.push(`/mensajes/${thread._id}`);
      }
    },
    updateUnread() {
      const unread = this.threads.filter((t) => t.unread).length;
      this.$store.commit('unread', unread);
      domestiko.messages(unread);
    },
  },
  template: `
      <div class="messages" :class="{list: !tid, detail: !!tid}">
      	<MessagesEmpty v-if="threads.length === 0"/>
      	<div v-if="threads.length > 0">
	      <div class="uk-grid uk-grid-collapse">
	        <div class="uk-width-1-2@m">
	        	<MessagesThreads 
			        :tid="tid"
			        :threads="threads"
			        @select="select"
		        />
            </div>
	        <div class="uk-width-1-2@m">
              <MessagesList 
	              :thread="selected"
	              @send="selected.updatedAt = new Date()"
	              @reset="select(threads.filter(t => t.status === 'publish')[0]) || null"
              />
            </div>	        
          </div>
        </div>
      </div>
	`,
};
